// extracted by mini-css-extract-plugin
export default {"warning":"warning--HofVK","rejection":"rejection--vw_db"};